// @flow
import React, { useState, Fragment } from 'react';
import { CS_Checkbox, CS_Space, CS_Text, CS_Input, CS_ScrollableContainer } from '../../visual_components';
import { CAREER_PAGE_FILTERS, searchWithFilter } from './CareersPageFilterService';
import type { CareersPageFilterItemType, CareersPageFiltersType } from './CareersPageFilterService';
import { isSubstring } from '../../careerPageUtils';

type CareersPageFiltersProps = {
	filters: CareersPageFiltersType,
	is_filter_available: boolean,
};

export default function CareersPageFilters(props: CareersPageFiltersProps) {
	const { filters, is_filter_available } = props;
	const FilterComponent = Object.entries(filters)
		.sort(([_, a_filter_data], [__, b_filter_data]) => a_filter_data.order - b_filter_data.order)
		.filter(([filter_key, filter_data]) => filter_data.options.length > 0)
		.map(([filter_key, filter_data], idx) => {
			return (
				<CareersPageFilter
					key={filter_key}
					filter_key={filter_key}
					filter_options={filter_data.options}
					first_item={idx === 0}
				/>
			);
		});
	return (
		<Fragment>
			{FilterComponent}
			{is_filter_available && (
				<Fragment>
					<CS_Space vertical size={5} />
					<div className="text-center">
						<a href="/">
							<button type="button" className="btn btn-grey">
								{' '}
								Clear Filters
							</button>
						</a>
					</div>
					<CS_Space vertical size={5} />
				</Fragment>
			)}
		</Fragment>
	);
}

type CareersPageFilterProps = {
	filter_key: string,
	filter_options: Array<CareersPageFilterItemType>,
	first_item: boolean,
};

function CareersPageFilter(props: CareersPageFilterProps) {
	const { filter_options, filter_key, first_item } = props;
	const filter_info = CAREER_PAGE_FILTERS[filter_key];
	const [search_param, onSearchChange] = useState('');
	return (
		<div>
			{!first_item && (
				<div>
					<CS_Space vertical size={5} />
					<div className="rb-divider" />
					<CS_Space vertical size={5} />
				</div>
			)}
			<CS_Text color="darker">{filter_info.label}</CS_Text>
			<CS_Space vertical size={3} />
			<CS_Input
				placeholder={`Enter ${filter_info.placeholder}`}
				full_width
				onChange={e => onSearchChange(e.target.value)}
			/>
			<CS_Space vertical size={3} />
			<CS_ScrollableContainer>
				{filter_options.map(filter_option => (
					<CareersPageFilterOption
						key={filter_option.option.id}
						filter_key={filter_info.query_name}
						filter_option={filter_option}
						search_param={search_param}
					/>
				))}
			</CS_ScrollableContainer>
		</div>
	);
}

type CareersPageFilterOptionProps = {
	filter_option: CareersPageFilterItemType,
	filter_key: string,
	search_param: string,
};

function CareersPageFilterOption(props: CareersPageFilterOptionProps) {
	const { filter_option, filter_key, search_param } = props;
	const { id, name } = filter_option.option;
	const is_visible = isSubstring(name, search_param);
	return (
		<div className={!is_visible ? 'hide' : ''}>
			<CS_Checkbox
				name={filter_key}
				value={id}
				defaultChecked={filter_option.selected}
				onChange={searchWithFilter}>
				{name} ({filter_option.count})
			</CS_Checkbox>
		</div>
	);
}
